//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        content: {
            type: String,
            default: ''
        },
        show: {
            type: Boolean,
            default: false
        },
        onHide: {
            type: Function,
        }
    },
    methods: {
        _onHide() {
            this.onHide && typeof this.onHide === 'function' && this.onHide();
        }
    }
}



// WEBPACK FOOTER //
// ./src/vue-components/pop/alert.vue